module.exports = __webpack_public_path__ + "img/cat-7.a086217a.svg";